class PriceRangeSlider extends HTMLElement {
  constructor() {
    super();

    let _this = this;
    let sliderSections = this.getElementsByClassName("range-bar-slider");
    
    for(const element of sliderSections){
      let sliders = element.getElementsByTagName("input");
      for(const element of sliders){
        if(element.type ==="range" ){
          element.oninput = _this.getVals;
          element.oninput();
        }
      }
    }
  }
  
  // Get Price value from both range slider
  getVals(){
    let parentEl = this.parentNode;
    let slides = parentEl.getElementsByTagName("input");
    let slide1 = parseFloat(slides[0].value);
    let slide2 = parseFloat(slides[1].value);
    let slidemax = parseFloat(slides[1].max);
    let rangemove = document.querySelectorAll('.rangeslider');

    rangemove.forEach(rangeEl => {
      rangeEl.style.left = slide1*100/slidemax + "%";
      rangeEl.style.right = slide2*100/slidemax + "%";
      rangeEl.style.width = (slide2*100/slidemax - slide1*100/slidemax) + "%" ; 
    })
      
    // Neither slider will clip the other, so make sure we determine which is larger
    if( slide1 > slide2 ){ let tmp = slide2; slide2 = slide1; slide1 = tmp; }
    
    let priceEle = parentEl.getElementsByClassName("price-range-value")[0];
    priceEle.innerHTML = formatMoney((slide1*100), window.globalVariables.money_format)+ ' - ' + formatMoney((slide2*100), window.globalVariables.money_format);
  }
}
customElements.define('range-bar-slider', PriceRangeSlider);